import React, { useEffect } from "react";
import cookie from "js-cookie";
import axios from "axios";
import { Routes, Route, Navigate } from "react-router-dom";
import { isLoggedIn, logout } from "../../utils/auth";
import API_URL from "../../config";
import AIChat from "./AIChat";
import Home from "./dealers/Home";
import CreateDealer from "./dealers/CreateDealer";
import AddConsignee from "./consignee/addConsignee";
import Atcgodown from "./Godown";
import AtcCreategodown from "./Godown/CreateGodown";
import AtcViewgodown from "./Godown/viewGodown";
import AtcViewDealer from "./dealers/viewDealer";
import AtcEditDealer from "./dealers/EditDealer";
import AtcEditGodown from "./Godown/EditGodown";
import AtcTransactionsView from "./dealers/viewDealerTrans";
import AtcGodwonRefillTrans from "./Godown/viewGodownTrans";
import AtcGodwonPartyTrans from "./Godown/GodownPartyTrans";
import ATCGodownpartyreturns from "./Godown/viewGodownReturns";
import ATCReports from "./Reports";
import ControllerSection from "./dealers/controller";
import AtcAddProduct from "./dealers/addProduct";
import ProductsPage from "./products";
import ConsigneeHome from "./consignee";
import ViewConsignee from "./consignee/viewConsignee";
import ViewConsigneeTrans from "./consignee/viewConsigneeTrans";
import PortalTopBar from "./TopBar";

const AtcPortalMain = () => {
    let validUser = isLoggedIn();

    // Presence heartbeat — tells the admin console this user is online
    // while their portal is open (only when the tab is visible).
    useEffect(() => {
        if (!validUser) return undefined;
        const beat = () => {
            if (document.visibilityState === "visible") {
                axios.post(`${API_URL}/heartbeat`).catch(() => {});
            }
        };
        beat();
        const timer = setInterval(beat, 45000);
        return () => clearInterval(timer);
    }, [validUser]);

    if (validUser) {
        const loginname = cookie.get("_loginname");
        const companyname = cookie.get("_companyname") || "Portal";
        const accountStatus = cookie.get("_accountstatus") || null;
        const aiChatEnabled = cookie.get("_aichat") === "1";
        return (
            <div className="atcportal-main">
                <PortalTopBar logoutHandler={logout} />
                <ControllerSection
                    loginName={loginname}
                    companyName={companyname}
                    accountStatus={accountStatus}
                    aiChatEnabled={aiChatEnabled}
                    logoutHandler={logout}
                />
                <div className="view-section-main">
                    <Routes>
                        <Route index element={<Home />} />
                        <Route
                            path="ai-chat"
                            element={aiChatEnabled ? <AIChat /> : <Navigate to="/atcportal" replace />}
                        />
                        <Route path="dealers" element={<Home />} />
                        <Route path="createdealer" element={<CreateDealer />} />
                        <Route path="addconsignee" element={<AddConsignee />} />
                        <Route path="godown" element={<Atcgodown />} />
                        <Route path="creategodown" element={<AtcCreategodown />} />
                        <Route path="addproduct" element={<AtcAddProduct />} />
                        <Route path="products" element={<ProductsPage />} />
                        <Route path="viewgodown/:id" element={<AtcViewgodown />} />
                        <Route path="dealer/:id" element={<AtcViewDealer />} />
                        <Route path="editprofile/:id" element={<AtcEditDealer />} />
                        <Route path="editgodown/:id" element={<AtcEditGodown />} />
                        <Route path="transactions/:id" element={<AtcTransactionsView />} />
                        <Route path="godownrefilltransactions/:id" element={<AtcGodwonRefillTrans />} />
                        <Route path="godownpartytransaction/:id" element={<AtcGodwonPartyTrans />} />
                        <Route path="godownpartyreturns/:id" element={<ATCGodownpartyreturns />} />
                        <Route path="reports" element={<ATCReports />} />
                        <Route path="consignees" element={<ConsigneeHome />} />
                        <Route path="consignee/:id" element={<ViewConsignee />} />
                        <Route path="viewconsigneetransactions/:id" element={<ViewConsigneeTrans />} />
                    </Routes>
                </div>
            </div>
        );
    } else {
        return <Navigate to="/login" replace />;
    }
};

export default AtcPortalMain;
